import { JetView } from 'webix-jet';
import { devConfig, profile } from 'config/config';

/**
 * Class representing the table view for balance adjustments.
 * @extends JetView
 */
export default class tableBalanceAdjustmentsView extends JetView {
    /**
     * Configures the datatable view.
     * @returns {Object} The configuration object for the datatable.
     */
    config() {
        const _ = this.app.getService('locale')._;
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat);
        return {
            view: 'datatable',
            id: 'datatable',
            css: 'webix_header_border webix_data_border webix_footer_border',
            select: true,
            scrollY: true,
            columns: [
                { id: 'Id', header: 'Id', width: 100, sort: 'int' },
                {
                    id: 'DateAt',
                    header: _('Fecha'), // Localized header for date
                    fillspace: 0,
                    minWidth: 0,
                    width: 200,
                    sort: 'text',
                    format: dateFormat, // Date formatting function
                },
                { id: 'Type', header: _('Tipo'), width: 200, sort: 'int' }, // Localized header for type
                {
                    id: 'UserTo',
                    header: _('Receptor'), // Localized header for receiver
                    width: 300,
                    sort: 'int',
                },
                {
                    id: 'UserFrom',
                    header: _('Emisor'), // Localized header for sender
                    width: 300,
                    sort: 'int',
                },
                {
                    id: 'ReferenceId',
                    header: _('Referencia'), // Localized header for reference
                    width: 200,
                    sort: 'int',
                },
                {
                    id: 'Description',
                    header: _('Descripción'), // Localized header for description
                    width: 500,
                    sort: 'int',
                },
            ],
            on: {
                /**
                 * Event triggered before loading data.
                 * Displays a loading overlay.
                 */
                onBeforeLoad: function () {
                    this.showOverlay(
                        "<div id='contenedor'; class='container-preload'><div style='position: fixed; top: calc(50% - 57px);left: calc(50% - 60px);width: 120px;' class='progress'><div class='icon-preload girando'></div><div class='load-text'>Loading... </div></div></div>",
                    );
                },
                /**
                 * Event triggered after loading data.
                 * Hides the loading overlay.
                 */
                onAfterLoad: function () {
                    this.hideOverlay();
                },
            },
            /**
             * Event triggered when the datatable is ready.
             * Displays a message if no data is present.
             */
            ready: function () {
                if (!this.count()) {
                    webix.extend(this, webix.OverlayBox);
                    this.showOverlay(
                        "<div class='no-data' style='margin:75px; font-size:18px;'>" +
                            _('No hay datos') + // Localized message for no data
                            '</div>',
                    );
                }
            },
            tooltip: true,
            math: true,
            loadahead: 0,
            datafetch: devConfig.getDefaultDataFetch(), // Fetching configuration
            pager: 'pagerA', // Pager ID
        };
    }

    /**
     * Initializes the datatable and sets up event listeners.
     * @param {Object} grid - The datatable instance.
     */
    init(grid) {
        const _ = this.app.getService('locale')._;
        var filter = ''; // Filter string for API requests
        var url = devConfig.geturlApi() + 'Client/GetNotes'; // API endpoint for fetching notes
        var options = []; // Options for the note types
        var popupAdd; // Popup for adding a new note

        // Event listener for filtering data
        this.on(this.app, 'filter', (filterData) => {
            var object = Object.entries(filterData);
            var string1 = ''; // Query string for filters
            for (var i = 0; i < object.length; i++) {
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    if (object[i][0] == 'Datepicker') {
                        var date = object[i][1].split(' - ');
                        string1 = string1 + '&DateFrom=' + date[0];
                        string1 = string1 + '&DateTo=' + date[1];
                    } else {
                        if (object[i][0] != 'Date') {
                            string1 = string1 + '&' + object[i][0] + '=' + object[i][1];
                        } else {
                            if (object[i][0] == 'Date') {
                                var date = object[i][1].replace(' 00:00:00', '');
                                string1 = string1 + '&DateFrom=' + date;
                                string1 = string1 + '&DateTo=' + date;
                            }
                        }
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        var object2 = Object.entries(object[i][1]);
                        for (var j = 0; j < object2.length; j++) {
                            if (object2[j][1] !== null) {
                                if (object2[j][0] === 'start') {
                                    var d = new Date(object2[j][1]);
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom;
                                } else {
                                    if (object2[j][0] === 'end') {
                                        var d = new Date(object2[j][1]);
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo;
                                    }
                                }
                            }
                        }
                    }
                }
            }
            grid.clearAll(); // Clear existing data in the grid
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1); // Load filtered data
            filter = string1; // Update filter string
        });

        // Event listener for sorting data
        grid.attachEvent('onAfterSort', function (by, dir, as) {
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + filter + '&sort[' + by + ']=' + dir);
        });

        // Event listener for item click
        grid.attachEvent('onItemClick', function (id, e, node) {
            var item = this.getItem(id);
            this.$scope.app.callEvent('user:id', [item.Id]); // Trigger user ID event
        });

        // Event listener for player selection
        this.on(this.app, 'player:select', (Id) => {
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + '&PlayerId=' + Id);
        });

        // AJAX request to fetch note types
        webix
            .ajax()
            .headers({
                'Content-type': 'application/json',
            })
            .post(devConfig.geturlApi() + 'Select/GetNoteTypes', '', {
                error: function (text, data, XmlHttpRequest) {
                    webix.message('Error! '); // Error message on failure
                },
                success: function (text, data, XmlHttpRequest) {
                    var resp = JSON.parse(text); // Parse response
                    resp.Data.forEach((item) => {
                        item.id = item.Id; // Set id for options
                        item.value = item.Description; // Set value for options
                    });
                    options = resp.Data; // Store options
                    $$('Type').define('options', resp.Data); // Define options for the combo
                    $$('Type').refresh(); // Refresh the combo
                    popupAdd = webix.ui({
                        view: 'window',
                        id: 'AddNote',
                        width: 450,
                        height: 450,
                        fullscreen: screen.width > 500 ? false : true,
                        head: {
                            view: 'toolbar',
                            cols: [
                                {
                                    view: 'label',
                                    label: _('Crear Nota'), // Localized label for creating note
                                    align: 'center',
                                },
                                {
                                    view: 'icon',
                                    icon: 'wxi-close',
                                    click: function () {
                                        this.getTopParentView().hide(); // Close popup on icon click
                                    },
                                },
                            ],
                        },
                        position: 'center',
                        modal: true,
                        body: {
                            view: 'form',
                            id: 'addform',
                            elements: [
                                {
                                    view: 'text',
                                    label: _('Receptor:'), // Localized label for receiver
                                    name: 'UserTo',
                                    labelWidth: 150,
                                    required: true,
                                },
                                {
                                    view: 'combo',
                                    label: _('Tipo') + ':', // Localized label for type
                                    name: 'Type',
                                    required: true,
                                    options: options, // Options for the combo
                                    labelWidth: 150,
                                },
                                {
                                    view: 'textarea',
                                    label: _('Descripción:'), // Localized label for description
                                    name: 'Description',
                                    labelWidth: 150,
                                    required: true,
                                },
                                {
                                    view: 'text',
                                    label: _('Referencia:'), // Localized label for reference
                                    name: 'ReferenceId',
                                    labelWidth: 150,
                                    required: true,
                                },
                                {
                                    cols: [
                                        {
                                            view: 'button',
                                            value: _('Cancelar'), // Localized label for cancel button
                                            click: function () {
                                                this.getTopParentView().hide(); // Close popup on cancel
                                                $$('addform').setValues(
                                                    $$('addform').getCleanValues(), // Clear form values
                                                );
                                            },
                                        },
                                        {
                                            view: 'button',
                                            type: 'form',
                                            value: _('Guardar'), // Localized label for save button
                                            click: function ($e) {
                                                var values = $$('addform').getValues(); // Get form values
                                                if ($$('addform').validate()) {
                                                    // Validate form
                                                    webix
                                                        .ajax()
                                                        .headers({
                                                            'Content-type': 'application/json',
                                                        })
                                                        .post(
                                                            devConfig.geturlApi() + 'Client/CreateNote',
                                                            '{"UserTo":"' +
                                                                values.Type +
                                                                '", "Type":"' +
                                                                values.Type +
                                                                '", "Description":"' +
                                                                values.Description +
                                                                '", "ReferenceId":"' +
                                                                values.ReferenceId +
                                                                '"}',
                                                            {
                                                                error: function (text, data, XmlHttpRequest) {
                                                                    webix.message('Error! '); // Error message on failure
                                                                },
                                                                success: function (text, data, XmlHttpRequest) {
                                                                    var json = JSON.parse(text); // Parse response
                                                                    if (json.HasError) {
                                                                        webix.message({
                                                                            title: _(
                                                                                '¡Error!', // Localized error title
                                                                            ),
                                                                            type: 'alert-error',
                                                                            text: json.AlertMessage, // Display error message
                                                                        });
                                                                    } else {
                                                                        webix.message(
                                                                            'Nota Creada', // Success message
                                                                        );
                                                                        grid.clearAll(); // Clear grid data
                                                                        grid.load(
                                                                            url +
                                                                                '?start=0&count=' +
                                                                                grid.data.$pagesize +
                                                                                filter, // Reload grid data
                                                                        );
                                                                    }
                                                                },
                                                            },
                                                        );
                                                    $$('addform').setValues(
                                                        $$('addform').getCleanValues(), // Clear form values
                                                    );
                                                    this.getTopParentView().hide(); // Close popup
                                                } else {
                                                    webix.message({
                                                        title: _('¡Error!'), // Localized error title
                                                        type: 'alert-error',
                                                        text: _(
                                                            'Completa los campos...', // Localized error message
                                                        ),
                                                    });
                                                }
                                            },
                                        },
                                    ],
                                },
                            ],
                            elementsConfig: {
                                on: {
                                    /**
                                     * Event triggered on change of form elements.
                                     * Validates the form.
                                     */
                                    onChange: function () {
                                        this.validate();
                                    },
                                },
                            },
                        },
                    });
                },
            });

        // Event listener for adding adjustments
        this.on(this.app, 'addAdjustment:button', (item) => {
            if (options.length > 0) {
                popupAdd.show(); // Show popup if options are available
                $$('addform').clearValidation(); // Clear previous validation
            } else {
                webix.message({
                    text: _('Datos no han podido ser cargados'), // Localized error message
                    title: _('¡Error!'), // Localized error title
                    type: 'alert-error',
                });
            }
        });
    }
}

// FILE DOCUMENTED
